<template>
  <div id="firebaseui-auth-container"></div>
</template>

<script>
import { firebaseUI } from "@lib/firebase";
import firebase from "@lib/firebase";
import "firebaseui/dist/firebaseui.css";
import { getCountry } from "@lib/utility/ipUtils";

export default {
  async mounted() {
    let self = this;
    let countryCode = "US";
    const uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: function (e) {
          self.$emit("login-success", e.user);
        },
      },
      signInFlow: "popup",
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          defaultCountry: "US",
        },
      ],
    };
    try {
      countryCode = await getCountry();
      uiConfig.signInOptions[2].defaultCountry = countryCode;
    } catch (error) {
      console.error(error);
    }
    firebaseUI.start("#firebaseui-auth-container", uiConfig);
  },
};
</script>

<style lang="scss">
@import "~@lib/styles/helpers";

#firebaseui-auth-container {
  @include for-desktop {
    margin: 48px 32px;
  }

  .firebaseui-card-content {
    @include for-mobile {
      padding: 0;
    }
  }
}
</style>
